<div class="queue-page">
  <div class="queue-header">
    <h1>Company review</h1>
    <p>Every company registered on the platform, awaiting or already reviewed.</p>
  </div>

  <div class="count-card count-card--blue">
    <div class="count-card__icon"><span class="material-icons">domain</span></div>
    <div class="count-card__text">
      <span class="count-card__main"><strong>{{ totalCount() }}</strong> Companies</span>
      <span class="count-card__status">{{ statusFilterLabel }}</span>
    </div>
  </div>

  <div class="tabs">
    <button [class.active]="statusFilter() === 'PENDING'" (click)="setFilter('PENDING')">Pending</button>
    <button [class.active]="statusFilter() === 'APPROVED'" (click)="setFilter('APPROVED')">Approved</button>
    <button [class.active]="statusFilter() === 'REJECTED'" (click)="setFilter('REJECTED')">Rejected</button>
    <button [class.active]="statusFilter() === 'SUSPENDED'" (click)="setFilter('SUSPENDED')">Suspended</button>
    <button [class.active]="statusFilter() === ''" (click)="setFilter('')">All</button>
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p>Loading...</p>
  } @else if (companies().length === 0) {
    <app-empty-state message="No companies in this status." />
  } @else {
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Registration No.</th>
          <th>Country</th>
          <th>Contact email</th>
          <th>Status</th>
          <th>Registered</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (company of companies(); track company.id) {
          <tr>
            <td><a [routerLink]="['/admin/companies', company.id]">{{ company.name }}</a></td>
            <td>{{ company.registrationNo }}</td>
            <td>{{ company.countryCode }}</td>
            <td>{{ company.contactEmail }}</td>
            <td><app-status-badge [status]="company.status" /></td>
            <td>{{ company.createdAt | date: 'medium' }}</td>
            <td>
              <span class="actions">
                @if (company.status === 'PENDING') {
                  <button (click)="approve(company)">Approve</button>
                  <button class="reject-btn" (click)="reject(company)">Reject</button>
                } @else if (company.status === 'APPROVED') {
                  <button class="suspend-btn" (click)="suspend(company)">Suspend</button>
                } @else if (company.status === 'SUSPENDED') {
                  <button (click)="reactivate(company)">Reactivate</button>
                }
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages() - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount() }} companies</span>
      </div>
    </div>
  }
</div>
